import { Component, AfterViewInit, Input, ViewChild, ElementRef } from '@angular/core';
import Konva from 'konva';
import { LanguageService } from '../../../../shared/services/language.service';

@Component({
  selector: 'app-ams-trend-line',
  templateUrl: './ams-trend-line.component.html',
  styleUrls: ['./ams-trend-line.component.css']
})
export class AmsTrendLineComponent implements AfterViewInit {
  private static idCounter = 0;
  
  @ViewChild("trendLine") trendLineDiv: ElementRef;
  private id: string = null;
  @Input() valueField: string;
  private _data: any;

  @Input() width: number = null;
  @Input() height: number = null;

  @Input() set data(d) {
    this._data = d;
  }
  get data(): any {
    return this._data;
  }



  constructor(public ls: LanguageService) {
    this.width = 120;
    this.height = 20;
    this._data = null;
    this.valueField = null;
  }

  ngAfterViewInit() {
    const tld = this.trendLineDiv.nativeElement as HTMLDivElement;
    if (tld.id === "") {
      tld.id = "trendLine_" + (++AmsTrendLineComponent.idCounter).toString();
    }
    this.id = tld.id;
    this.paint();
  }

  paint() {
    if (this._data === null || this._data.length === 0 || this.valueField === null || this.width === null || this.height === null)
      return;

    try {
      const width = 1.0 * this.width;
      const height = 1.0 * this.height;

      const stage = new Konva.Stage({
        container: this.id,
        width: width,
        height: height,
      });


      const d = this._data;
      const points: number[] = [];
      const chartWidth = width * 0.95;
      const chartHeight = height * 0.85;
      const xOffset = (width - chartWidth) / 2.0;
      const dx = Math.max(1, chartWidth / d.length);
      let minV = d[0][this.valueField], maxV = minV;
      for (let i = 0; i < d.length; i++) {
        if (d[i][this.valueField] < minV) {
          minV = d[i][this.valueField];
        }
        else if (d[i][this.valueField] > maxV) {
          maxV = d[i][this.valueField];
        }
      }
      const yFactor = chartHeight / ((maxV - minV) * (1.30));
      for (let i = 0; i < d.length; i++) {
        points.push(xOffset + dx * i);
        points.push(Math.min((height - 1), Math.max(0, chartHeight - (d[i][this.valueField] * yFactor))));
      }

      const layer = new Konva.Layer();

      const redLine = new Konva.Line({
        points: points,
        stroke: 'red',
        strokeWidth: 2,
        lineCap: 'round',
        lineJoin: 'round',
        tension: 0.7,
      });

      layer.add(redLine);
      stage.add(layer);
    } catch (e) {
      //do nothing
    }

  }

}
